import { overviewRoute } from "src/containers/overview/routeConfig";
import { resumeRoute, resumeMenu } from "src/containers/resume/routeConfig";
import { portfolioRoute, portfolioMenu } from "src/containers/portfolio/routeConfig";
import { autobioRoute, autobioMenu } from "src/containers/autobio/routeConfig";

export const routeConfig = [overviewRoute, resumeRoute, portfolioRoute, autobioRoute];

export const menuConfig = [resumeMenu, portfolioMenu, autobioMenu];